<template>
  <div class="video-page-wrapper">
    <IphoneVideo :video-name="require('@/assets/videos/create_scenes.mp4')"></IphoneVideo>
    <PageTabs>
      <template v-slot:first>
        <div class="video-page-texts video-page-texts-no-offset page-tabs-margin-top-lg">
          <div>
            <h3>{{ $t("pages.scenes.subtitle1") }}</h3>
            <p>{{ $t("pages.scenes.text1") }}</p>
          </div>
          <div>
            <h3>{{ $t("pages.scenes.subtitle2") }}</h3>
            <p>{{ $t("pages.scenes.text2") }}</p>
          </div>
        </div>
      </template>
      <template v-slot:second>
        <VoiceCommands :commands="commands" class="page-tabs-margin-top-lg"></VoiceCommands>
      </template>
    </PageTabs>

  </div>
</template>

<script>
import PageTabs from "../components/PageTabs";
import VoiceCommands from "../components/VoiceCommands";
export default {
  name: "Scenes",
  components: { VoiceCommands, PageTabs },
  data() {
    return {
      commands: this.$t("pages.scenes.commands")
    };
  }
};
</script>
